export default __webpack_public_path__ + "static/media/portfolio.2d4f8cc9.gif";